import { Icon, type SvgIconProps } from "@mui/material";
import { ComponentType, lazy, Suspense } from "react";

interface IProps {
  icon: string | null | undefined;
  color?: string | null;
  size?: number;
}

const DynamicIcon = (props: IProps) => {
  const { icon, color, size } = props;

  if (!icon) return <div style={{ width: 20, height: 24 }} />;

  return <Icon sx={{ color: color, fontSize: size }}>{icon}</Icon>;
};

export default DynamicIcon;
